export enum Brand {
	Mango = 'mango',
	Mng = 'mng',
}

export interface TemplateParams {
	mng?: Brand
	brand?: string
	country?: string
	plp?: string
	isOutlet?: boolean
}

export function capitalizeWord(word: string) {
	return word.charAt(0).toUpperCase() + word.slice(1)
}

const OUTLET_TITLE = 'OUTLET'

/**
 * @example
 * [Plp name] [Año]| [Marca] [País]
 * [Nombre PDP] - [Brand] | [Marca] [País]
 * Iniciar sesión | [Marca] [País]
 * Moda de [Brand] | [Marca] [País]
 * [Marca] [País] | Moda online
 */
export function getPageTitleByTemplate(
	template: string,
	templateParams: TemplateParams
) {
	const currentYear = new Date().getFullYear().toString()
	/**
        %1$s | %b => Mango | MNG
        %2$s | %c => Country
        %3$s | %y => Year
        %4$s | %g => Gender (Brand)
        %5$s | %n => Plp name
    */
	const mng = /%1\$s|%b/g
	const country = /%2\$s|%c/g
	const year = /%3\$s|%y/g
	const brand = /%4\$s|%g/g
	const plpName = /%5\$s|%n/g

	const mngOutlet = templateParams.isOutlet ? ` ${OUTLET_TITLE}` : ''
	const mngBrand = `${(templateParams.mng ?? '').toUpperCase()}${mngOutlet}`
	return template
		?.replace(mng, mngBrand)
		.replace(year, currentYear)
		.replace(country, templateParams.country ?? '')
		.replace(plpName, capitalizeWord(templateParams.plp ?? ''))
		.replace(brand, capitalizeWord(templateParams.brand ?? ''))
}
